import React, { type ReactElement } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import Image from '@/components/image/image'
import useDefaultImages from '@/hooks/useDefaultImages'

import * as styles from './header-episode.module.scss'

type HeaderEpisodeProps = {
  episode: Queries.EpisodeQuery['datoCmsPctEpisode']
}

const HeaderEpisode = ({
  episode
}: Readonly<HeaderEpisodeProps>): ReactElement => {
  const { imgHeaderEpisode } = useDefaultImages('DatoCmsPctEpisode')

  if (episode == null) {
    return <></>
  }
  const { externalName, excerpt, image } = episode
  return (
    <header className={styles.header}>
      <div className={styles.bgImage}>
        <Image image={image ?? imgHeaderEpisode?.desktop} />
      </div>
      <Container className={styles.containerHeader}>
        <Row className="justify-content-center">
          <Col lg="12" className="text-center">
            <div className={styles.topic}>
              <p>NTT DATA Insurance Thought Leadership Podcast</p>
            </div>
            <h1>{externalName}</h1>
            <Row className="justify-content-center">
              <Col xg="9" className="text-center">
                <p className={styles.excerpt}>{excerpt}</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </header>
  )
}

export default HeaderEpisode
